import {
  Box,
  Center,
  Heading,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { Web3Provider } from "@ethersproject/providers";
import { useWeb3React } from "@web3-react/core";
import Head from "next/head";
import React, { useEffect, useState } from "react";
import RaiderCardLayout from "../components/ui/layouts/RaiderCardLayout";
import Shell from "../components/ui/layouts/Shell";
import {
  getRecruitmentStatus
} from "../util/web3/interactRecruiting";
import { Raider } from "../types/raider";
import { ownedRaidersIds } from "../util/web3/interactBank";

export default function Recruiting() {
  const [canRecruitRaiders, setCanRecruitRaiders] = useState<Raider[]>([]);
  const [cantRecruitRaiders, setCantRecruitRaiders] = useState<Raider[]>([]);
  const context = useWeb3React<Web3Provider>();
  const { account } = context;
  const [tabChange, setTabChange] = useState<boolean>();

  const [isLoading, setIsLoading] = useState(false);
  const [allRaiders, setAllRaiders] = useState<Raider[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const raiderIds = await ownedRaidersIds();
      const statusResponse = await getRecruitmentStatus(raiderIds.map(rid => Number(rid)));
      setCanRecruitRaiders([]);
      setAllRaiders(allRaiders.concat(statusResponse.recruitable))
      setCantRecruitRaiders([]);
      setAllRaiders(allRaiders.concat(statusResponse.unrecruitable))
      setIsLoading(false);
      //setCantRecruitRaiders(allRaiders);

    };

    fetchData();
  }, [account, tabChange]);

  return (
    <Shell>
      <Head>
        <title>Crypto Raiders - Recruiting</title>
      </Head>
      <Box as="section" pb="20">
        <Box bg="gray.700" pt="20" pb="20">
          <Box
            maxW={{ base: "xl", md: "7xl" }}
            mx="auto"
            px={{ base: "6", md: "8" }}
          >
            <Box mb="6" color="white" maxW="xl">
              <Heading
                size="2xl"
                letterSpacing="tight"
                fontWeight="extrabold"
                lineHeight="normal"
                fontFamily="Press Start 2P"
              >
                ⚔️ Your Raiders
              </Heading>
              <Text fontSize="lg" mt="0" fontWeight="medium" color="gray.200">
                You have{" "}
                {canRecruitRaiders === undefined
                  ? "-"
                  : canRecruitRaiders?.length}{" "}
                raiders available for recruiting!
              </Text>
              <Text  mt="4" color="gray.400">
                Recruitment is currently paused.
              </Text>
              {/* <Text fontSize="sm" mt="4" color="gray.400" mb="5">
                If you&apos;ve already started recruiting, hit the spawn button
                to see your new Raiders.
              </Text>
              <Button colorScheme="green" onClick={() => spawnRaiders()}>
                Spawn
              </Button> */}
            </Box>
          </Box>
        </Box>
        <Box mt="-20">
          <Box
            maxW={{ base: "xl", md: "7xl" }}
            mx="auto"
            px={{ base: "6", md: "8" }}
          >
            <Center hidden={!isLoading}>
              <div className="sk-folding-cube">
                <div className="sk-cube1 sk-cube"></div>
                <div className="sk-cube2 sk-cube"></div>
                <div className="sk-cube4 sk-cube"></div>
                <div className="sk-cube3 sk-cube"></div>
              </div>
            </Center>
            <Tabs
              isFitted
              variant="enclosed"
              mt={10}
              onChange={() => setTabChange(!tabChange)}
            >
              <TabList mb="1em">
                <Tab>Available ({canRecruitRaiders.length})</Tab>
                <Tab>Waiting ({cantRecruitRaiders.length})</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <RaiderCardLayout 
                    raiders={canRecruitRaiders}
                    isLoading={isLoading}
                    button="recruit"
                  />
                </TabPanel>
                <TabPanel>
                  <RaiderCardLayout 
                    raiders={cantRecruitRaiders}
                    isLoading={isLoading}
                    button="recruit"
                  />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Box>
      </Box>
    </Shell>
  );
}
